angular.module('rings-app.pages', ['rings-app.grandfather'])
.config(function ($stateProvider,$urlRouterProvider) {
  // For any unmatched url, send to /route1
  $urlRouterProvider.otherwise("/home")

  $stateProvider
  .state('app.foreign', {       // je abstraktni stav dojde k automatickemu presmerovani na home stranku admina
      url: '/foreign',
      abstract:true,
      templateUrl: 'pages/foreign.tpl.html',
      accessLevel: accessLevels.foreign,
    })
    .state('app.foreign.home', {
      url: '',
      templateUrl: 'pages/foreign.home.tpl.html',
      accessLevel: accessLevels.foreign,
    })
    .state('app.foreign.retraps', {
      url: '/retraps',
      templateUrl: 'pages/foreign.retraps.tpl.html',
      accessLevel: accessLevels.foreign,
    })
    .state('app.foreign.observation', {
      url: '/observation',
      templateUrl: 'pages/foreign.observation.tpl.html',
      accessLevel: accessLevels.foreign,
    })
    .state('app.admin', {       // je abstraktni stav dojde k automatickemu presmerovani na home stranku admina
      url: '/admin',
      abstract:true,
      templateUrl: 'pages/admin.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.users', {
      url: '/users',
      templateUrl: 'pages/admin.users.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.orders', {
      url: '/orders',
      templateUrl: 'pages/admin.orders.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.stock', {
      url: '/stock',
      templateUrl: 'pages/admin.stock.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.rings', {
      url: '/rings',
      templateUrl: 'pages/admin.rings.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.retraps', {
      url: '/retraps?q',
      templateUrl: 'pages/admin.retraps.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.observation', {
      url: '/observation',
      templateUrl: 'pages/admin.observation.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.projects', {
      url: '/projects',
      templateUrl: 'pages/admin.projects.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.history', {
      url: '/history',
      templateUrl: 'pages/admin.history.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.reports', {
      url: '/reports',
      templateUrl: 'pages/admin.reports.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.admin.simpleinsert', {
      url: '/simple-insert',
      templateUrl: 'pages/admin.simple-insert.tpl.html',
      accessLevel: accessLevels.admin,
    })
    .state('app.user', {
      url: '/user',
      abstract:true,
      templateUrl: 'pages/user.tpl.html',
      accessLevel: accessLevels.user
    })
    .state('app.user.home', {
      url: '',
      templateUrl: 'pages/user.home.tpl.html',
      accessLevel: accessLevels.user,
    })
    .state('app.user.observation', {
      url: '/observation?idloc',
      templateUrl: 'pages/user.observation.tpl.html',
      accessLevel: accessLevels.user,
    })
    .state('app.user.observation.detail', {
      url: '/detail?id&q',
      templateUrl: 'pages/user.observation-detail.tpl.html',
      accessLevel: accessLevels.user,
    })
    .state('app.user.records', {
      url: '/records/:q',
      templateUrl: 'pages/user.records.tpl.html',
      accessLevel: accessLevels.user
    })
    .state('app.user.rings', {
      url: '/rings',
      templateUrl: 'pages/user.rings.tpl.html',
      accessLevel: accessLevels.user,
    })
    .state('app.user.recovery', {
      url: '/recovery',
      templateUrl: 'home/recovery.tpl.html',
      accessLevel: accessLevels.public,
    })
    .state('app.user.pigeon', {
      url: '/pigeon',
      templateUrl: 'home/pigeon.tpl.html',
      accessLevel: accessLevels.public,
    })
    .state('app.user.olddata', {
      url: '/olddata',
      templateUrl: 'pages/admin.simple-insert.tpl.html',
      accessLevel: accessLevels.olddata,
    });
});
